import { render, staticRenderFns } from "./modalForgotPassword.vue?vue&type=template&id=7ed6ed2d&"
import script from "./modalForgotPassword.vue?vue&type=script&lang=js&"
export * from "./modalForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports